module.exports = __webpack_public_path__ + "img/logo-blue-stamp@2x.67bf8f06.png";